module.exports = __webpack_public_path__ + "e7058dd0f2ded1ea9aeea88fe23dc538.png";